import { useEffect, useState } from 'react';
import { ALBUM } from '../config';
import { ArrowUpRight, Close } from './Icons';

// A note in the nav's own black that drops down from under it.
export default function AlbumPopup() {
  const [open, setOpen] = useState(false);

  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setOpen(true), 1200);
    return () => clearTimeout(t);
  }, []);

  // The nav is sticky, so tuck the ticket away while scrolling rather than let it cover the page.
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const shown = open && !scrolled;
  const tabIndex = shown ? 0 : -1;

  return (
    <div
      role="dialog"
      aria-label="New album"
      aria-hidden={!shown}
      className={`absolute left-1/2 top-full z-50 mt-3 w-[calc(100%-1.5rem)] max-w-md -translate-x-1/2 transition duration-700 ease-[cubic-bezier(0.2,0.8,0.2,1)] ${
        shown ? 'translate-y-0 opacity-100' : 'pointer-events-none -translate-y-8 opacity-0'
      }`}
    >
      <div className="flex items-center gap-4 border border-bone/15 bg-black py-3 pl-4 pr-2 text-bone">
        <div className="flex min-w-0 flex-1 flex-col gap-0.5">
          <span className="truncate font-times text-xl lowercase md:text-2xl">{ALBUM.title}</span>
        </div>
        <a
          href={ALBUM.url}
          target="_blank"
          rel="noopener noreferrer"
          tabIndex={tabIndex}
          className="group flex items-center gap-1.5 whitespace-nowrap font-times text-lg text-mustard transition-colors hover:text-bone"
        >
          listen
          <ArrowUpRight className="inline-block transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
        </a>
        <button
          onClick={() => setOpen(false)}
          aria-label="Close"
          tabIndex={tabIndex}
          className="flex h-9 w-9 items-center justify-center font-times text-lg text-bone/50 transition-colors hover:text-bone"
        >
          <Close />
        </button>
      </div>
    </div>
  );
}
